import { fixedBody, unFixedBody, forceResetBody } from './lib/fixedBody'

const initPostDetailHandlers = () => {
	console.log('Initializing post detail handlers...')

	// エラー時の強制リセット用
	window.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			const activeModal = document.querySelector('.js-postdetail--content.active')
			if (activeModal) {
				closePostDetail(activeModal.dataset.key)
			}
		}
	})

	$(window)
		.off('postdetail:open')
		.on('postdetail:open', function(event, key, id) {
			console.log('postdetail:open', key, id)
			const $content = $(`.js-postdetail--content[data-key="${key}"]`)

			if ($content.length) {
				try {
					$content.addClass('active')
					fixedBody()
					history.pushState(null, null, `/posts/${id}`)
				} catch (error) {
					console.error('Error opening post detail:', error)
					forceResetBody()
				}
			}
		})

	$(window)
		.off('postdetail:close')
		.on('postdetail:close', function(event, key, id) {
			closePostDetail(key)
		})
}

const closePostDetail = (key) => {
	console.log('Closing post detail:', key)
	const $content = $(`.js-postdetail--content[data-key="${key}"]`)

	if ($content.length) {
		try {
			$content.removeClass('active')
			unFixedBody()
			history.pushState(null, null, '/posts')
		} catch (error) {
			console.error('Error closing post detail:', error)
			forceResetBody()
		}
	}
}

const initPostDetailButtons = () => {
	$('.js-postdetail--open')
		.off('click')
		.on('click', function(event) {
			event.preventDefault()
			const key = $(this).data('key')
			const id = $(this).data('id')
			$(window).trigger('postdetail:open', [key, id])
		})

	$('.js-postdetail--close')
		.off('click')
		.on('click', function(event) {
			event.preventDefault()
			const key = $(this).data('key')
			closePostDetail(key)
		})
}

document.addEventListener('turbolinks:load', function() {
	console.log('turbolinks:load - initializing post detail')
	initPostDetailHandlers()
	initPostDetailButtons()

	// 既存のモーダルが開いていた場合は強制的にリセット
	forceResetBody()

	const pattern = /^\/posts\/(\d+)$/
	const match = location.pathname.match(pattern)
	const post_id = match ? Number(match[1]) : null

	if (post_id) {
		const key = `postid${post_id}`
		setTimeout(() => {
			$(window).trigger('postdetail:open', [key, post_id])
		}, 100)
	}
})

// ページ遷移時のクリーンアップ
document.addEventListener('turbolinks:before-visit', () => {
	forceResetBody()
})
